import "./SitemapComponent.css";

const SitemapComponent = () => {
    return (
        <div className="aboutUsBlock">
            <div className="aboutus-hero-banner">
                <div className="container">
                    <h1>Site Map</h1>
                </div>
            </div>
            <div className="container-body">

            </div>
        </div>
    );
};
export default SitemapComponent;